import * as Sentry from "@sentry/browser";

/**
 *
 * @param {import("vue-router").Router} router
 * @returns {import("vue").FunctionPlugin}
 */
export function createSentry(router) {
  return function (app) {
    if (import.meta.env.PROD) {
      // Vue 3 error handler
      app.config.errorHandler = (err, instance, info) => {
        Sentry.captureException(err, {
          extra: {
            componentName: instance?.["type"]?.["name"],
            lifecycleHook: info,
          },
        });
      };

      // Router errors
      router.onError((error) => {
        Sentry.captureException(error, {
          tags: { section: "router" },
        });
      });

      router.beforeEach((to, from) => {
        Sentry.addBreadcrumb({
          category: "navigation",
          message: `${from.fullPath} → ${to.fullPath}`,
          level: "info",
        });
      });
    }
  };
}
